export default __webpack_public_path__ + "static/ally-b8278b12062fc10185b3ddb54f8e731a.jpg";